// noinspection DuplicatedCode

import {initCKEditor, insertAtSelection} from "../../../helpers/inputs/ckeditor/ckeditor";
import Axios from "axios";
import {handleAjaxSuccess} from "../../../helpers/swalHelper";
import handleAjaxError from "../../../helpers/handleAjaxError";
import {loading, stopLoading} from "../../../helpers/loading";
import createElement from "../../../helpers/createElement";
import Swal from "sweetalert2";
import {createModal} from "../../../helpers/modals/modal";
import {waitUntil} from "../../../helpers/waitUntil";
import {getSingleInputElementByNameV3} from "../../../helpers/forms/formInputsHelpers";

function initEmailTemplatesIndex() {
	// Init shared modal
	const previewModal = createModal({
		modalContainer: null,
	});

	// Get all email templates containers
	document.querySelectorAll('.settings-emails-pane')
		.forEach(container => {
			// Retrieve template
			const templateCurrentValue = container.querySelector('input[name="existing_template"]')
				.value;

			// Init subject inputs
			const subjectElement = getSubjectInput(container);

			if (subjectElement) {
				// We need to keep track if the subject element was the last focused element
				subjectElement.addEventListener('focus', () => {
					// Add focused class when clicked
					subjectElement.classList.add('focused')

					// Remove class after focus is lost
					waitUntil(() => subjectElement !== document.activeElement)
						.then(() => {
							// Removed focus, but only after a while so other events
							// are processed first
							setTimeout(() => {
								subjectElement.classList.remove('focused');
							}, 64)
						})
				})
			}

			// Initialize WYSIWYG editor
			let editor;
			const editorElement = container.querySelector('.editor');

			initCKEditor(editorElement).then(newEditor => {
				// Save editor reference
				editor = newEditor

				// Set editor value
				editor.setData(templateCurrentValue);

				// Remove loading overlay
				editorElement.parentElement.parentElement.classList.remove('loading');

				// Init placeholders
				container.querySelectorAll('.placeholder-trigger').forEach(trigger => {
					trigger.addEventListener('click', () => {
						let placeholderString;
						if (trigger.classList.contains('conditional-placeholder')) {
							// Conditional placeholder
							placeholderString = `@IF{${trigger.dataset.placeholder}} text if condition is true @ELSE text if condition is false @ENDIF`;
						} else {
							// Default placeholder
							placeholderString = trigger.dataset.placeholder
						}

						const subjectInput = getSubjectInput(container);

						// Check if subject input exists and is focused
						if (subjectInput && subjectInput.classList.contains('focused')) {
							const caretPosition = subjectInput.selectionEnd;

							// Place on subject
							subjectInput.value =
								subjectInput.value.slice(0, caretPosition) +
								placeholderString +
								subjectInput.value.slice(caretPosition)

							// Reposition caret
							setTimeout(() => {
								subjectInput.focus();
								subjectInput.selectionStart = caretPosition + placeholderString.length;
								subjectInput.selectionEnd = caretPosition + placeholderString.length;
							}, 64)

						} else {
							// Place on editor
							insertAtSelection(editor, placeholderString);
						}
					})
				});
			});

			// Setup buttons
			const previewButton = container.querySelector('.preview-button');

			if (previewButton) {
				previewButton.addEventListener('click', () => {
					previewEmail(editor, previewButton.dataset.route, container)
				})
			}

			const storeButton = container.querySelector('.save-template-button');

			if (storeButton) {
				storeButton.addEventListener('click', () => {
					storeTemplate(editor, storeButton.dataset.route, container)
				})
			}

			const sendTestButton = container.querySelector('.send-test-button');

			if (sendTestButton) {
				sendTestButton.addEventListener('click', () => {
					sendTestEmail(editor, sendTestButton.dataset.route, container)
				})
			}
		});

	// Init tab select
	// noinspection JSValidateTypes
	/** @var {HTMLSelectElement} */
	const tabSelect = getSingleInputElementByNameV3(document.body, 'tab');

	tabSelect.addEventListener('change', () => {
		handleTabChange();
	})

	/**
	 * Methods
	 */
	function storeTemplate(editor, route, container) {
		loading();
		const data = editor.getData();

		Axios.post(
			route,
			{
				template: data,
				subject: getSubjectStringIfSet(container),
			}
		)
			.then(response => {
				handleAjaxSuccess(response, () => {
				})
			})
			.catch(handleAjaxError)
			.finally(stopLoading)
	}

	function previewEmail(editor, route, container) {
		loading();
		const data = editor.getData();

		Axios.post(
			route,
			{
				template: data,
				subject: getSubjectStringIfSet(container),
			}
		)
			.then(response => {
				previewModal.replace(
					createElement(response.data.modal)
				);

				previewModal.display();
			})
			.catch(handleAjaxError)
			.finally(stopLoading)
	}

	function sendTestEmail(editor, route, container) {
		Swal.fire({
			title: 'Enter Target Email Address',
			input: 'text',
			showCancelButton: true,
			inputValidator: (value) => {
				if (!value) {
					return 'Please type an email address'
				}
			}
		}).then(result => {
			if (result.value) {
				loading();
				const data = editor.getData();

				Axios.post(
					route,
					{
						template: data,
						email: result.value,
						subject: getSubjectStringIfSet(container),
					}
				)
					.then(response => {
						handleAjaxSuccess(response, () => {
						})
					})
					.catch(handleAjaxError)
					.finally(stopLoading)
			}
		})
	}

	/**
	 * @param container
	 * @returns {HTMLInputElement|null}
	 */
	function getSubjectInput(container) {
		return container.querySelector('input[name="subject"]');
	}

	function getSubjectStringIfSet(container) {
		const subjectInput = getSubjectInput(container);
		if (subjectInput) {
			return subjectInput.value;
		} else {
			return '';
		}
	}

	function handleTabChange() {
		const relatedTab = $(`#${tabSelect.selectedOptions[0].value}`);
		relatedTab.tab('show');
	}
}


export {initEmailTemplatesIndex}
